import React from 'react'
import { AreaEditorProps, DashboardAreaKeys } from '../../types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import DashboardArea from '../DashboardArea'
import { DASHBOARD_EDITOR_SUMMARY_AREA_ID } from 'src/Libs/qa/ids'

/**
 * Summary area for the dashboard editor
 */
const SummaryArea: React.FC<AreaEditorProps> = ({ hidden, setHidden, position, getMenuItems, disabled }) => {
  const { t } = useCustomTranslation()

  return (
    <DashboardArea
      areaKey={DashboardAreaKeys.summary}
      name={t('dashboard.editor.summary')}
      hidden={hidden}
      setHidden={setHidden}
      position={position}
      getMenuItems={getMenuItems}
      disabled={disabled}
      dataQa={DASHBOARD_EDITOR_SUMMARY_AREA_ID}
    />
  )
}

export default SummaryArea
